<div class="form-field-container d-flex flex-column" [formGroup]="formGroup" [ngStyle]="{
    '--border-color': control.touched && control.invalid ? 'red' : '#afcbe0'
  }">
  @if (label != '') {
  <label>{{ label }}</label>
  }
  <div class="input-container">
    <span style="flex: 1 0 auto;">{{ control.value | dfnsFormat:'dd.MM.yyyy' }}</span>
    <div>
      <button mat-icon-button (click)="selectDate()" [disabled]="control.disabled">
        <mat-icon svgIcon="calendar"></mat-icon>
      </button>
    </div>

  </div>
  @if (control.touched && control.invalid) {
  <div class="form-validation-error-container">
    @if (control.errors?.['required']) {
    <small>Dette felt er påkrævet.</small>
    }
    @if (control.errors?.['dateBefore']) {
    <small>Udsendelsesdato skal være før eller samme dato som event</small>
    }
  </div>
  }

</div>
